<template>
    <div id="feature-wrap">
        <div id="feature-media">
            <img :id="ids.mediaDisplayType" :src="source" :alt="name" :title="name" @load="SetDisplayType()"/>
        </div>
    </div>
</template>

<script>
export default {
    name: "ProjectFeature",
    props: {
        projectID: Number,
        name: String,
        media: Array
    },
    data: () => ({
        source: "",
        ids: { mediaDisplayType: "" },
        feature: {}
    }),
    methods: {
        GetSource: function() {
            const { TimelineProjectMapID, Source } = this.feature;
            this.source = require(`@/assets/Images/Projects/${this.projectID}/${TimelineProjectMapID}/Feature/${Source}`);
        },

        // Check for media display type
        SetDisplayType: function() {
            let mediaDisplayType = "";
            const { DisplayType } = this.feature;
            if (DisplayType === "Landscape") {
                mediaDisplayType = "media-landscape";
            }
            if (DisplayType === "Isolated") {
                mediaDisplayType = "media-isolated";
            }
            this.ids.mediaDisplayType = mediaDisplayType;
            this.$emit("media-display-type", DisplayType);
        },

        GetMedia: function() {
            this.feature = this.media[0];
            this.GetSource();
        }
    },
    beforeMount: function() { this.GetMedia(); },
    updated: function() { this.GetMedia(); },
    emits: [ "media-display-type" ]
};
</script>